import { TipoControl } from "./formulario-dinamico.model";

/**
 * Modelo estructura dinamica
 *
 * @export
 * @class EstructuraVista
 */
export class EstructuraVista {
    nombre: string;
    alias?: string;
    id: number;
    orden: number;
    tipo: TipoControl;
    propiedades: any;
    condiciones: any;
  }

/**
 * Modelo de vista
 *
 * @export
 * @class VistaSolicitudesVital
 */
export class VistaSolicitudesVital {
    nombre: string;
    descripcion: string;
    id: number;
    estructura: EstructuraVista[];
  }


// WEBPACK FOOTER //
// ./src/app/shared/models/solicitudes-vital.model.ts